import StatCard from "../../common/StatCard";
import { formatCurrency } from "../../../utils/formatters";
import { Ticket, Package, TrendingUp, Calendar } from "lucide-react";

const ReportSummaryCards = ({ report }) => {
  const totalTicketRevenue =
    report.events?.reduce((sum, e) => sum + (e.ticketRevenue ?? 0), 0) ?? 0;
  const totalExtrasRevenue =
    report.events?.reduce((sum, e) => sum + (e.extrasRevenue ?? 0), 0) ?? 0;
  const totalTicketsSold =
    report.events?.reduce((sum, e) => sum + (e.ticketsSold ?? 0), 0) ?? 0;
  const totalExtrasSold =
    report.events?.reduce((sum, e) => sum + (e.extrasSold ?? 0), 0) ?? 0;

  const stats = [
    {
      icon: <Calendar size={16} className="text-primary" />,
      label: "Total Events",
      value: report.events?.length ?? 0,
      accent: "bg-primary/10",
    },
    {
      icon: <Ticket size={16} className="text-tertiary" />,
      label: "Tickets Sold",
      value: totalTicketsSold.toLocaleString(),
      accent: "bg-tertiary/10",
    },
    {
      icon: <Package size={16} className="text-secondary" />,
      label: "Extras Sold",
      value: totalExtrasSold.toLocaleString(),
      accent: "bg-secondary/10",
    },
    {
      icon: <TrendingUp size={16} className="text-primary" />,
      label: "Total Revenue",
      value: formatCurrency(totalTicketRevenue + totalExtrasRevenue),
      accent: "bg-primary/10",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <StatCard key={s.label} {...s} />
      ))}
    </div>
  );
};

export default ReportSummaryCards;
